import React, { Component, PropTypes } from 'react';
import { withRouter } from 'react-router/es';
import { routeCodes } from 'constants/routes';
import { connect } from 'react-redux';

export default function ValidationLegalHOC(AuthComponent) {
  @connect(state => ({
    user: state.user.get('data'),
  }))
  class ValidationLegalComponent extends Component {
    static propTypes = {
      router: PropTypes.object,
      user: PropTypes.object,
    }

    componentWillMount(){
      const { router, user } = this.props;
      const agreedToLegal = user.get('agreedToLegal');
      if (!agreedToLegal) {
        router.push(routeCodes.VALIDATE_LEGAL);
      }
    }

    componentWillReceiveProps(nextProps) {
      const { router } = this.props;
      const agreedToLegal = nextProps.user.get('agreedToLegal');
      if (!agreedToLegal) {
        router.push(routeCodes.VALIDATE_LEGAL);
      }
    }

    render() {
      const { user, router } = this.props;
      const agreedToLegal = user.get('agreedToLegal');
      if (!agreedToLegal) {
        router.push(routeCodes.VALIDATE_LEGAL);
      }
      return (
        <AuthComponent { ... this.props } />
      );
    }
  }
  return withRouter(ValidationLegalComponent);
}
